
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cases/anchor",
      function () {
        return require("private-next-pages/cases/anchor/index.tsx");
      }
    ]);
  